import { Col, Radio, Row, Tag, Tooltip } from "antd"; // Añadido Tag y Tooltip
import { useFetch } from "../../../../../hooks/useFetch/useFetch";
import DrawerSG from "../../../../components/design/Drawer/DrawerSG";
import { SpinSG } from "../../../../components/model/Spin/SpinSG";
import { useState } from "react";
import TableSG from "../../../../components/design/Table/TableSG";
import moment from "moment"; // Asumiendo que usas moment por los mensajes anteriores

export const ExecutionLogsDrawer = ({ onClose, executionId }: any) => {

    const { data: logs, isLoading } = useFetch(`${process.env.REACT_APP_API}/services/${executionId}`, {}, []);
    
    const columns = [
        {
            title: 'Fecha',
            key: 'date',
            dataIndex: 'date',
            width: 180,
            render: (date: string) => (
                <div style={{fontSize: '12px'}}>
                    {moment.utc(date).local().format('D MMMM YYYY HH:mm:ss')}
                </div>
            )
        },
        {/*
            title: 'Origen / API',
            key: 'api',
            dataIndex: 'api',
            render: (api: string) => <b>{api}</b>
        */},
        {
            title: 'Estado',
            key: 'success',
            dataIndex: 'success',
            align: 'center',
            width: 100,
            render: (success: boolean) => (
                <Tag color={success ? 'green' : 'red'}>
                    {success ? 'OK' : 'KO'}
                </Tag>
            )
        },
        {
            title: 'Log',
            key: 'errorMessage',
            dataIndex: 'errorMessage',
            render: (msg: string) => {
                if (!msg || msg === "null") return <span style={{color: '#bfbfbf'}}>Sin detalles</span>;
                return (
                    <Tooltip title={msg}>
                        <div style={{ 
                            maxWidth: '300px', 
                            whiteSpace: 'nowrap', 
                            overflow: 'hidden', 
                            textOverflow: 'ellipsis',
                            fontSize: '11px'
                        }}>
                            {msg}
                        </div>
                    </Tooltip>
                );
            }
        }
    ];
    
    const EXECUTION_MAP: Record<string, string> = {
        "METALS_PRICING_LAST_MONTH": "Cotizaciones mensuales",
        "METALS_PRICING_LAST_YEAR": "Cotizaciones anuales",
        "METALS_PRICING_LAST_HOUR": "Cotizaciones horarias",
        "PRICES": "Precios",
        "WOOCOMMERCE_PRODUCTS_ALL": "Productos Wordpress",
        "WOOCOMMERCE_PRODUCTS_LAST_DAY": "Productos Wordpress",
        "WOOCOMERCE_ORDERS_ALL": "Ordenes WordPress diarias",
        "WOOCOMERCE_ORDERS_LAST_DAY": "Ordenes WordPress horarias",
        "WOOCOMERCE_CLIENTS_ALL": "Clientes WordPress",
        "PURGE_EXPIRED_DATA": "Eliminar registros antiguos",
        "UPLOAD_AUTOMATIC_PRICES": "Subida de Precio automático",
        "LIBERTAD_TOTAL": "Libertad Total"
    };

    const displayTitle = EXECUTION_MAP[executionId] || executionId;

    return (                 
            <DrawerSG
                title={
                    <div>
                        Logs de {displayTitle}
                    </div>
                }
                onClose={onClose}
                visible={true}
                width={800} 
                placement='right'>

                <TableSG 
                    dataSource={logs} 
                    columns={columns} 
                    loading={isLoading} 
                    pagination={{ pageSize: 20 }} 
                    //rowKey={(record: any) => record.date} // Usamos la fecha como key única
                />
                
            </DrawerSG>           
    )
}